import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export const trackStarAmountClickOnCrLandingPage = (starLink: HTMLElement) => {
    const numOfStars = starLink.dataset.numOfStars;
    const numOfReviews = starLink.dataset.numOfReviews;
    trackEvent({
        review_FilterReview: ['select'],
        review_FilterReviewStars: [String(numOfStars)],
        review_ReviewCount: [String(numOfReviews)],
    });
};
